import React from "react";

export const FacebookFilled = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 3C12.85 3 3 12.85 3 25C3 36.03 11.125 45.137 21.712 46.728V30.831H16.269V25.048H21.712V21.2C21.712 14.829 24.816 12.032 30.111 12.032C32.647 12.032 33.988 12.22 34.623 12.306V17.354H31.011C28.763 17.354 27.978 19.485 27.978 21.887V25.048H34.566L33.672 30.831H27.978V46.775C38.716 45.318 47 36.137 47 25C47 12.85 37.15 3 25 3Z"
        fill="currentColor"
      />
    </svg>
  );
};
